import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { PromotionsModule } from '@spartacus/storefront';
import { GenCartSharedModule } from '../cart-shared/cart-shared.module';
import { GenCartDetailsComponent } from './cart-details.component';
import { CartCouponModule, CartValidationWarningsModule, ClearCartModule } from '@spartacus/cart/base/components';

@NgModule({
  imports: [
    CommonModule,
    CartCouponModule,
    RouterModule,
    UrlModule,
    PromotionsModule,
    I18nModule,
    CartValidationWarningsModule,
    ClearCartModule,
    GenCartSharedModule,
  ],
  declarations: [GenCartDetailsComponent],
  exports: [GenCartDetailsComponent],
})
export class GenCartDetailsModule {}
